#import "../fragments/audience-stub-fragment.graphql"

mutation CreateAudience($audience: AudienceCreateInput!) {
    audienceCreate(input: $audience) {
        audience {
            ...AudienceStub
        }
    }
}
